import { cn } from '../../lib/utils'

interface ProgressBarProps {
  value: number      // 현재 사용량
  max: number        // 최대 한도
  label?: string
  showText?: boolean // 우측에 "value/max" 표시 여부
  size?: 'xs' | 'sm' | 'md'
  className?: string
}

// 사용 비율에 따라 색상 변화: <50% 녹, <80% 노랑, ≥80% 빨강
function getBarColor(pct: number) {
  if (pct >= 80) return 'bg-red-500'
  if (pct >= 50) return 'bg-amber-400'
  return 'bg-green-500'
}

const trackSizes = { xs: 'h-1', sm: 'h-1.5', md: 'h-2' }

export default function ProgressBar({
  value,
  max,
  label,
  showText = true,
  size = 'sm',
  className,
}: ProgressBarProps) {
  const pct = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0
  const barColor = getBarColor(pct)

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {(label || showText) && (
        <div className="flex items-center justify-between">
          {label && <span className="text-xs text-ink-muted">{label}</span>}
          {showText && (
            <span className={cn('text-xs font-medium tabular-nums', pct >= 80 ? 'text-red-400' : 'text-ink-faint')}>
              {value.toLocaleString()} / {max === -1 ? '∞' : max.toLocaleString()}
            </span>
          )}
        </div>
      )}
      <div className={cn('w-full bg-surface-elevated/50 rounded-full overflow-hidden', trackSizes[size])}>
        <div
          className={cn('h-full rounded-full transition-all duration-500', barColor)}
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={value}
          aria-valuemin={0}
          aria-valuemax={max}
        />
      </div>
    </div>
  )
}
